import { setHasReportedAppLoaded } from '../../common/store/app-loaded/app-loaded-actions';

export const appLoaded = fedopsAppLoaded => () => (dispatch, getState) => {
  fedopsAppLoaded();
  dispatch(setHasReportedAppLoaded());
};
